import N8nSwitch from './Switch.vue';

export default N8nSwitch;
export { N8nSwitch };
export { N8nSwitch as N8nSwitch2 };
export type * from './Switch.types';
